/**
 * The hosts Jot will talk to over plain `http://`, in one place because two very
 * different things state the same rule and disagreed when each stated it itself.
 *
 * ADR-0003 makes TLS mandatory: the production server is internet-facing, so the
 * bearer token is the sole access control and it travels on every request.
 * Loopback is the single exemption, for development — and it has to be spelled out
 * twice, once for the client that refuses an endpoint (`scratchpadEndpoint`) and
 * once for the renderer's CSP `connect-src`, which is what actually decides whether
 * a request leaves the process. The CSP is generated from this list at build time
 * (see `electron.vite.config.ts`) so the two cannot drift.
 *
 * Exact matches only: `localhost.example.com` resolves wherever its owner points
 * it, and `.localhost` subdomains would let one typo silently downgrade a real
 * deployment.
 *
 * `[::1]` is deliberately absent, and cannot be added. CSP has no syntax for an
 * IPv6 literal — Chromium 151 reports `http://[::1]:*` as "an invalid source: it
 * will be ignored", verified against a server genuinely listening on `::1` — so
 * accepting the address in the client would mean Settings showing no error while
 * the request is blocked before it is sent, which reads to the user as a server
 * that cannot be reached and can never be retried into working. `localhost`
 * resolves to `::1` on a v6 host, so nothing is out of reach.
 *
 * Anything added here widens the renderer's CSP by exactly one host-source, so it
 * must be a name that means "this machine" and nothing else.
 */
export const LOOPBACK_HOSTS = ['localhost', '127.0.0.1'] as const
